import React from 'react';
import { AuthState } from '@aws-amplify/ui-components';
import * as LayoutWrapper from 'cbs-layout-wrapper';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useAuthContext } from '../auth/auth';
import { SharedLink } from '../../../shared-link/shared-link';
import { CONTAINER_WIDTH } from '../../../../global/constants';

const AdminNavigation = React.lazy(
  () =>
    import('../navigation-sidebar/components/admin-navigation/admin-navigation'),
);

const useStyles = makeStyles(() => ({
  div: {
    '& *': {
      boxSizing: 'border-box',
    },
  },
}));

export const AppNavigation = () => {
  const classes = useStyles();
  const auth = useAuthContext();

  if (auth.authState == null) {
    return null;
  }

  if (auth.authState !== AuthState.SignedIn) {
    return (
      <div className={classes.div}>
        <LayoutWrapper.TopBar slogan="" LinkComponent={SharedLink} />
        <ModifiedHeader />
      </div>
    );
  }

  return <AdminNavigation />;
};

const useHeaderStyles = makeStyles(() => ({
  root: {
    '& nav': {
      maxWidth: `${CONTAINER_WIDTH}px`,
      boxSizing: 'content-box',
    },
  },
}));

function ModifiedHeader() {
  const classes = useHeaderStyles();

  return (
    <div className={classes.root}>
      <LayoutWrapper.Header linkComponent={SharedLink} />
    </div>
  );
}
